import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute h-screen overflow-y-auto w-screen md:grid md:grid-cols-1 mdgrid-rows-1 md:overflow-hidden md:overflow-y-hidden" }
const _hoisted_2 = { class: "md:row-start-1 md:row-span-1 md:col-start-1 md:col-span-1 flex flex-col h-home md:h-screen pb-2 md:pb-0 md:min-h-full overflow-hidden items-stretch justify-items-stretch" }
const _hoisted_3 = { class: "flex justify-center items-center flex-1 min-h-0 overflow-hidden lg:pb-20 md:pb-16" }
const _hoisted_4 = { class: "md:row-start-1 md:row-span-1 md:col-start-1 md:col-span-1 md:h-screen flex md:flex-col flex-col-reverse gap-4 md:gap-1" }

import AnimatedText from "../atoms/AnimatedText.vue";
import HomeMenu from "../organisms/HomeMenu.vue";
import MusicToolbar from "../organisms/MusicToolbar.vue";
import OptionsBar from "../organisms/OptionsBar.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AnimatedText)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(HomeMenu, { class: "justify-self-center self-center flex-1" }),
      _createVNode(MusicToolbar)
    ]),
    _createVNode(OptionsBar, { class: "absolute top-2 left-2" })
  ]))
}
}

})